import { FunctionComponent } from 'react';
import { useMasterData } from 'hooks/useMasterData';
import SelectComponent, { SelectOption } from '../SelectComponent/SelectComponent';

export interface FoodTypeProps {
    selectedOption?: number;
    className?: string;
    onSelect: (option: number) => void;
}

const FoodType: FunctionComponent<FoodTypeProps> = props => {
    const { foodTypes } = useMasterData();

    return (
        <SelectComponent
            label="Food Type"
            selectedOption={
                props.selectedOption
                    ? {
                          id: Number(props.selectedOption),
                          name: ''
                      }
                    : undefined
            }
            options={foodTypes}
            placeholder="Select Food Type"
            className={props.className}
            required={true}
            onSelect={(option: SelectOption) => props.onSelect(Number(option.id.toString()))}
        />
    );
};

export default FoodType;
